import { PaymentMeansUpdateRequest } from '~client/model/payment-means-update-request';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';

export const updatePaymentMethod = rxTask((request: PaymentMeansUpdateRequest) =>
  apiClient.paymentController.updatePaymentMethod$(request),
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/interactor/payment/update-payment-means.ts